import axios from "axios";
import * as apiURL from './apiURL';
import getCookie from "./getCookie";

/**
 * API2 로그아웃 라이브러리
 */
export default class Logout
{
    async logout() {
        const api2Client = this.getApi2Client();
        try {
            const response = await api2Client(apiURL.logout);
            return response.data;
        } catch(e) {
            console.error('Logout Request Error');
            throw e;
        }
    }

    getApi2Client() {
        const headers = {
            "Accept": "application/json",
        };
        const token = getCookie('auth_token');
        if(typeof token === 'string') {
            headers.token = token;
        }
        return axios.create({
            baseURL: apiURL.baseURL,
            withCredentials: true,
            'headers': headers,
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/util/auth/Logout.js